import "core-js/modules/es.array.map";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { ParticipationModel } from './model/participation';
import { getMapKey, isUndef } from '@/lib/utils';
var m = {
  namespaced: true,
  state: {
    list: {},
    signInStat: null,
    stat: null
  },
  mutations: {
    /**
     * 设置活动报名列表
     */
    setList: function setList(state, _a) {
      var key = _a.key,
          list = _a.list;
      Vue.set(state.list, key, list.map(function (item) {
        return new ParticipationModel(item);
      }));
    },

    /**
     * 记录统计数据
     */
    setSignInStat: function setSignInStat(state, stat) {
      state.signInStat = stat;
    },

    /**
     * 记录统计数据
     */
    setStat: function setStat(state, stat) {
      state.stat = stat;
    }
  },
  actions: {
    /**
     * 获取活动报名列表
     * activityId: 可不传
     * active: 默认 是，是否仅仅限于进行中
     * finish: 是否已完赛
     */
    getList: function getList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          activityId = _c.activityId,
          active = _c.active,
          finish = _c.finish;

      return __awaiter(this, void 0, void 0, function () {
        var params, key, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              params = {};
              console.log('target123123132123', activityId, active, finish);
              key = getMapKey({
                activityId: activityId,
                active: active,
                finish: finish
              });

              if (activityId) {
                params.activity_id = activityId;
              }

              if (!isUndef(active)) {
                params.active = active ? 1 : 0;
              }

              if (!isUndef(finish)) {
                params.finish = finish ? 1 : 0;
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/list', {
                params: params
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;
              console.log('target 报名数据1-1', rdata, key);

              if (rdata.status === 0) {
                commit('setList', {
                  key: key,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取活动报名列表
     */
    getSignInStat: function getSignInStat(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/sign_in_stat')];

            case 1:
              response = _b.sent();
              rdata = response.data;
              console.log('target 111111', rdata.data);

              if (rdata.status === 0) {
                commit('setSignInStat', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取数据统计
     */
    getStat: function getStat(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/stat')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setStat', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取套餐数据
     */
    getShowAlert: function getShowAlert() {
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/current')];

            case 1:
              res = _a.sent();
              rdata = res.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 弹窗
     */
    alert: function alert(context, id) {
      return __awaiter(this, void 0, void 0, function () {
        var res, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/alert', {
                participation_sign_in_id: id
              })];

            case 1:
              res = _a.sent();
              rdata = res.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;